import { PureComponent } from 'preact-compat'

import { ContentType } from '@insided/shared/utils/contentType'
import Button from '@insided/control/uikit/Button'
import { ParentCategory } from '../interfaces'
import { copyTopicToForum } from '../services/topicService'

/* eslint-disable import/no-internal-modules */
import Modal, { ModalHeader, ModalBody } from '@insided/deprecated-preact-components/design-system-components/modal'
import InputUnit from '@insided/deprecated-preact-components/design-system-components/input-unit'
import { createPublishedInFilter } from '@insided/control/modules/ContentModeration/ContentOverviews/Filters'

interface CategoriesSelectorRenderProps {
  isApplyButtonDisabled: boolean
  data: string[]
}
export interface CopyTopicProps {
  contentType: ContentType
  categories: ParentCategory[]
  topicId: number
  onClose: () => void
  onShowAlert: (type: 'success' | 'error', message?: string) => void
}

export interface CopyTopicState {
  categoryId: number | null
  isLoading: boolean
  selectedCategoryIds: string[] | null
}

class CopyTopicModal extends PureComponent<CopyTopicProps, CopyTopicState> {
  constructor(props: CopyTopicProps) {
    super(props)
    this.state = {
      categoryId: null,
      isLoading: false,
      selectedCategoryIds: []
    }

    this.onCopyToForum = this.onCopyToForum.bind(this)
  }

  async onCopyToForum(data: string[]) {
    const { onShowAlert, onClose, contentType, topicId } = this.props

    this.setState({ isLoading: true })
    try {
      await copyTopicToForum(contentType, topicId, [...data])
      onShowAlert('success', 'The topic has been successfully copied to the selected forum(s)')
      onClose()
    } catch {
      onShowAlert('error')
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { onClose, categories } = this.props
    const { selectedCategoryIds } = this.state
    /** @deprecated - create new multi-select searchable dropdown in @insided/control/uikit - see CAN-1254 */
    const { component: CategoriesSelector, items, id, name } = createPublishedInFilter(categories)

    return (
      <div className='copy-topic-modal'>
        <Modal onClose={onClose} isControl>
          <ModalHeader title='Copy to forum' />
          <ModalBody>
            <InputUnit label='Select the forum(s) where you wish to copy the topic to:' isControl>
              <div className='copy-topic-dropdown__list'>
                <CategoriesSelector id={id} name={name} items={items} selectedFilterItems={selectedCategoryIds ?? []}>
                  {({ isApplyButtonDisabled, data }: CategoriesSelectorRenderProps) => (
                    <div>
                      <hr />
                      <div className=''>
                        <Button
                          size='medium'
                          variant='brand'
                          data-qa='copy-to-forum'
                          title='Copy to forum'
                          disabled={isApplyButtonDisabled}
                          onClick={async () => await this.onCopyToForum(data)}
                        />
                        <Button size='medium' title='Cancel' onClick={onClose} />
                      </div>
                    </div>
                  )}
                </CategoriesSelector>
              </div>
            </InputUnit>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default CopyTopicModal
